var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page" }, [
    _c("div", { staticClass: "content-section content-page" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row justify-content-center" }, [
          _c(
            "div",
            { staticClass: "col-md-10" },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("h1", [_vm._v("Instructions Price")]),
              _vm._v(" "),
              _c("page-navigation"),
              _vm._v(" "),
              _c("h3", { staticClass: "border__btm" }, [
                _vm._v("What is an instructional price for electricity?")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Instruction agreement, advance price, single price, normal price, instruction fee or advance agreement - dear child has many names. However, what is common to these agreements is that it is the electricity contract that a customer is awarded when they do not make an active choice. Instruction price is also by far the most expensive form of agreement available on the Swedish market. Therefore, one should usually make sure to avoid assignment agreements in order not to pay an expensive electricity price unnecessarily. The most common case when awarding an assignment agreement is that you have moved into a new home and have not chosen an agreement on your own. When you move, there can be many other things that will end up in the place and that you need to stand in. It can also be that you are not sure how to even change an electricity contract, or which player is the cheapest in the area you have moved. to."
                )
              ]),
              _vm._v(" "),
              _c("h3", { staticClass: "border__btm" }, [
                _vm._v("Avoid directions and save money")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "As a rule, all electricity contracts are cheaper than the instructions contracts that are awarded. This is why you should actively choose an electricity contract before moving in. However, there can be a big difference between electricity contracts and electricity contracts. This is why you should always make a free comparison of the electricity contracts that can be signed in your area with TecknaEl. This way you can save money on the electricity bill every month even if you do not have an electricity contract with a guide price. Comparison services such as TecknaEl also give you good advice when choosing electricity companies, as it can otherwise be difficult to get into the electricity market. This allows you to easily save money on the energy bill ."
                )
              ]),
              _vm._v(" "),
              _c("h3", { staticClass: "border__btm" }, [
                _vm._v(
                  "Compare electricity contracts and find the best agreement"
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "It is not unusual to find yourself with a contract for electricity. In fact, almost every seventh household in Sweden already has a licensing agreement today, since they have not made an active choice of electricity companies. This means that hundreds of thousands of households pay a far, much higher electricity price than they really needed. Whether you choose an electricity contract with a variable or fixed price, you can expect this to be cheaper than an assignment agreement. In short, the guide price is something that consumers should avoid - but at the same time it can be difficult to gain insight into the electricity market and know what to choose. Simply put it isa electricity companies cheaper than the terms you get with a guide price for electricity. Therefore, use TecknaEl today to Compare different electricity contracts in your area, och hitta rätt val för dig - oavsett om detta är det avtal som är mest miljövänligt eller billigast."
                )
              ]),
              _vm._v(" "),
              _c("h3", { staticClass: "border__btm" }, [
                _vm._v("Electricity area 1")
              ]),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("h3", { staticClass: "border__btm" }, [
                _vm._v("Electricity area 2")
              ]),
              _vm._v(" "),
              _vm._m(2)
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "return" }, [
      _c(
        "a",
        {
          staticClass: "return_link p-green router-link-active",
          attrs: { href: "/kwh" }
        },
        [
          _c("img", {
            attrs: {
              src: require("../../../img/icon/arrow-down-green.svg"),
              alt: ""
            }
          }),
          _vm._v(
            "\n                        Vad är kWh (kilowattimme)?\n                    "
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "table" }, [
      _c("table", { staticClass: " first-col-blue last-col-green" }, [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("Company")]),
            _vm._v(" "),
            _c("th", [_vm._v("Agreement type")]),
            _vm._v(" "),
            _c("th", [_vm._v("Default rate")]),
            _vm._v(" "),
            _c("th", [_vm._v("Electricity price")]),
            _vm._v(" "),
            _c("th", [_vm._v("%")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: { src: require("../../../img/fortum.svg"), alt: "" }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Fortum")])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("Fortum Simple")]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: {
                  src: require("../../../img/gotlands_elforsaljning_ab.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Gotland's Electricity Sales")])
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v('Additional price "Refers to electricity area 3)')
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: {
                  src: require("../../../img/vasterbergslagens_elforsaljning_ab.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Västerberglagen's Electricity Sales")])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("Fortum Simple")]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: { src: require("../../../img/fortum.svg"), alt: "" }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Fortum")])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("Fortum Simple")]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: {
                  src: require("../../../img/gotlands_elforsaljning_ab.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Gotland's Electricity Sales")])
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v('Additional price "Refers to electricity area 3)')
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: {
                  src: require("../../../img/vasterbergslagens_elforsaljning_ab.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Västerberglagen's Electricity Sales")])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("Fortum Simple")]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: { src: require("../../../img/fortum.svg"), alt: "" }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Fortum")])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("Fortum Simple")]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: {
                  src: require("../../../img/gotlands_elforsaljning_ab.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Gotland's Electricity Sales")])
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v('Additional price "Refers to electricity area 3)')
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: {
                  src: require("../../../img/vasterbergslagens_elforsaljning_ab.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Västerberglagen's Electricity Sales")])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("Fortum Simple")]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: { src: require("../../../img/fortum.svg"), alt: "" }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Fortum")])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("Fortum Simple")]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: {
                  src: require("../../../img/gotlands_elforsaljning_ab.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Gotland's Electricity Sales")])
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v('Additional price "Refers to electricity area 3)')
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: {
                  src: require("../../../img/vasterbergslagens_elforsaljning_ab.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Västerberglagen's Electricity Sales")])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("Fortum Simple")]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: { src: require("../../../img/fortum.svg"), alt: "" }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Fortum")])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("Fortum Simple")]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: {
                  src: require("../../../img/gotlands_elforsaljning_ab.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Gotland's Electricity Sales")])
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v('Additional price "Refers to electricity area 3)')
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: {
                  src: require("../../../img/vasterbergslagens_elforsaljning_ab.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Västerberglagen's Electricity Sales")])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("Fortum Simple")]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: { src: require("../../../img/fortum.svg"), alt: "" }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Fortum")])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("Fortum Simple")]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: {
                  src: require("../../../img/gotlands_elforsaljning_ab.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Gotland's Electricity Sales")])
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v('Additional price "Refers to electricity area 3)')
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: {
                  src: require("../../../img/vasterbergslagens_elforsaljning_ab.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Västerberglagen's Electricity Sales")])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("Fortum Simple")]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: { src: require("../../../img/fortum.svg"), alt: "" }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Fortum")])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("Fortum Simple")]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: {
                  src: require("../../../img/gotlands_elforsaljning_ab.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Gotland's Electricity Sales")])
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v('Additional price "Refers to electricity area 3)')
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: {
                  src: require("../../../img/vasterbergslagens_elforsaljning_ab.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Västerberglagen's Electricity Sales")])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("Fortum Simple")]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "table" }, [
      _c("table", { staticClass: " first-col-blue last-col-green" }, [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("Company")]),
            _vm._v(" "),
            _c("th", [_vm._v("Agreement type")]),
            _vm._v(" "),
            _c("th", [_vm._v("Default rate")]),
            _vm._v(" "),
            _c("th", [_vm._v("Electricity price")]),
            _vm._v(" "),
            _c("th", [_vm._v("%")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: { src: require("../../../img/fortum.svg"), alt: "" }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Fortum")])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("Fortum Simple")]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: {
                  src: require("../../../img/gotlands_elforsaljning_ab.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Gotland's Electricity Sales")])
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v('Additional price "Refers to electricity area 3)')
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: {
                  src: require("../../../img/vasterbergslagens_elforsaljning_ab.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Västerberglagen's Electricity Sales")])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("Fortum Simple")]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: { src: require("../../../img/fortum.svg"), alt: "" }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Fortum")])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("Fortum Simple")]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: {
                  src: require("../../../img/gotlands_elforsaljning_ab.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Gotland's Electricity Sales")])
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v('Additional price "Refers to electricity area 3)')
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: {
                  src: require("../../../img/vasterbergslagens_elforsaljning_ab.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Västerberglagen's Electricity Sales")])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("Fortum Simple")]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: { src: require("../../../img/fortum.svg"), alt: "" }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Fortum")])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("Fortum Simple")]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: {
                  src: require("../../../img/gotlands_elforsaljning_ab.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Gotland's Electricity Sales")])
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v('Additional price "Refers to electricity area 3)')
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: {
                  src: require("../../../img/vasterbergslagens_elforsaljning_ab.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Västerberglagen's Electricity Sales")])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("Fortum Simple")]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: { src: require("../../../img/fortum.svg"), alt: "" }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Fortum")])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("Fortum Simple")]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: {
                  src: require("../../../img/gotlands_elforsaljning_ab.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Gotland's Electricity Sales")])
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v('Additional price "Refers to electricity area 3)')
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: {
                  src: require("../../../img/vasterbergslagens_elforsaljning_ab.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Västerberglagen's Electricity Sales")])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("Fortum Simple")]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: { src: require("../../../img/fortum.svg"), alt: "" }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Fortum")])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("Fortum Simple")]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: {
                  src: require("../../../img/gotlands_elforsaljning_ab.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Gotland's Electricity Sales")])
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v('Additional price "Refers to electricity area 3)')
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: {
                  src: require("../../../img/vasterbergslagens_elforsaljning_ab.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Västerberglagen's Electricity Sales")])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("Fortum Simple")]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: { src: require("../../../img/fortum.svg"), alt: "" }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Fortum")])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("Fortum Simple")]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: {
                  src: require("../../../img/gotlands_elforsaljning_ab.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Gotland's Electricity Sales")])
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v('Additional price "Refers to electricity area 3)')
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: {
                  src: require("../../../img/vasterbergslagens_elforsaljning_ab.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Västerberglagen's Electricity Sales")])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("Fortum Simple")]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: { src: require("../../../img/fortum.svg"), alt: "" }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Fortum")])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("Fortum Simple")]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: {
                  src: require("../../../img/gotlands_elforsaljning_ab.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Gotland's Electricity Sales")])
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v('Additional price "Refers to electricity area 3)')
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _c("img", {
                attrs: {
                  src: require("../../../img/vasterbergslagens_elforsaljning_ab.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Västerberglagen's Electricity Sales")])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("Fortum Simple")]),
            _vm._v(" "),
            _c("td", [_vm._v("117.09 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("62.34 öre / kWh")]),
            _vm._v(" "),
            _c("td", [_vm._v("47%")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }